import React from "react";
import { Grid } from "@material-ui/core";
import { useStyles } from "./style";

//defaults to 500px tall but height can be passed as a numeric value

function ResponsiveGridContainer({ height = 500, ...others }) {
  const classes = useStyles();
  return (
    <Grid
      {...others}
      className={classes.responsiveGridContainer}
      item
      xs={12}
      style={{
        width: "100%",
        minHeight: height,
        height: height,
        paddingBottom: 50
      }}
    />
  );
}

export default ResponsiveGridContainer;
